/**
 * @author Andrés Camilo Ferreira Rodríguez
 * @Copyright (c) Infotrack. All rights reserved.
 */
import { useProveedor } from '@infotrack/presentacion-componentes/proveedorEstado';
import Texto from '@infotrack/presentacion-componentes/texto';
import { TipoFormulario } from '@infotrack/presentacion-transversales/interfacesComunes';
import { useInputState } from '@infotrack/presentacion-utilitarios/hooks';
import {
    manejadorDialogoGlobal,
    manejadorIndicadorCargaGlobal,
} from '@infotrack/presentacion-utilitarios/manejadoresComponentes';
import IFamilias from 'Infotrack@Modelos/smartStock/familias/entidades/familias';
import { IEstadoGlobal } from 'Infotrack@Reductores/interfacesReductores';
import React from 'react';
import { connect } from 'react-redux';
import FamiliasCM from '../controladorModelo/familiasCM';
import { IFormularioFamiliasCVProps } from '../interfaces';
import { acciones, IEstadoFamilias } from '../reductorFamilias';
import FormularioFamiliasVista from '../vista/formularioFamiliasVista';
import { useSelector } from 'react-redux';
const estadoInicial: IFamilias = {
    EmpresaId: '',
    FamiliaDescripcion: '',
    Estado: 1,
    AgenciaId: '',
};
const familiasCM = new FamiliasCM();

const FormularioFamiliasCV: React.FunctionComponent<IFormularioFamiliasCVProps> = ({ IdEmpresa }) => {
    const idAgencia = useSelector((estado: IEstadoGlobal) => estado.estadoAutenticacion.agenciaActual!.IdAgencia);
    const [{ estadoFormulario, tipoFormulario, entidadFamilias }, dispatch] = useProveedor<IEstadoFamilias>();
    const { alCambiarValor, setValor, reiniciar, valor } = useInputState<IFamilias>(estadoInicial);

    React.useEffect(() => {
        if (entidadFamilias && tipoFormulario !== TipoFormulario.Creacion) {
            setValor(entidadFamilias);
        } else {
            reiniciar();
        }
    }, [entidadFamilias]);

    const cerrarFormulario = () => {
        dispatch({ type: acciones.CAMBIAR_ESTADO_FORMULARIO, payload: null });
    };
    const confirmarCreacionEdicionFamilias = () => {
        if (familiasCM.validarEntidad(valor)) {
            manejadorDialogoGlobal({
                accionCancelar: () => manejadorDialogoGlobal({ estado: false }),
                accionConfirmar: crearEditarFamilias,
                estado: true,
                mensaje: (
                    <Texto
                        id={
                            tipoFormulario === TipoFormulario.Creacion
                                ? 'alerta.confirmacionCreacion'
                                : 'alerta.confirmacionEdicion'
                        }
                    />
                ),
                mostrarCancelar: true,
                tipoDialogo: 'Advertencia',
                titulo: <Texto id="titulo.advertencia" />,
            });
        }
    };

    const crearEditarFamilias = () => {
        manejadorDialogoGlobal({ estado: false });
        manejadorIndicadorCargaGlobal(true);
        if (tipoFormulario === TipoFormulario.Creacion) {
            familiasCM
                .crearFamilias({
                    ...valor,
                    AgenciaId: idAgencia,
                    EmpresaId: IdEmpresa,
                    Estado: valor.Estado === true || valor.Estado === 1 ? 1 : 0,
                })
                .then(() => {
                    cerrarFormulario();
                    manejadorIndicadorCargaGlobal(false);
                    dispatch({ type: acciones.RECARGAR_TABLA });
                });
        } else {
            familiasCM
                .editarFamilias({
                    ...valor,
                    AgenciaId: idAgencia,
                    EmpresaId: IdEmpresa,
                    Estado: valor.Estado === true || valor.Estado === 1 ? 1 : 0,
                })
                .then(() => {
                    cerrarFormulario();
                    manejadorIndicadorCargaGlobal(false);
                    dispatch({ type: acciones.RECARGAR_TABLA });
                });
        }
    };

    return (
        <FormularioFamiliasVista
            accionCrearEditar={confirmarCreacionEdicionFamilias}
            cambiarInfoFomulario={alCambiarValor}
            familias={valor}
            cerrarFormulario={cerrarFormulario}
            estadoFormulario={estadoFormulario}
            tipoFormulario={tipoFormulario}
        />
    );
};

const estadoAPropiedades = ({
    estadoAutenticacion: { usuarioInformacion },
}: IEstadoGlobal): IFormularioFamiliasCVProps => ({
    IdEmpresa: usuarioInformacion!.IdEmpresa,
});

export default connect<IFormularioFamiliasCVProps, null, any, IEstadoGlobal>(
    estadoAPropiedades,
    null
)(FormularioFamiliasCV);
